import _ from 'lodash';
import moment from 'moment';
import { addSpecialHourToFirebase, removeSpecialHourOnFirebase } from '../../apis/shop.service';
import { ERROR_HORAIRE_SPECIFIC, ERROR_SAME_HOUR, INCOHERENT_HOURS } from '../../constants';

const checkHours = (slots, service) => {
  const { start = '00:00', end = '23:59' } = service;
  const entireSlot = `${start}-${end}`;
  if (start < end || end !== start) {
    slots.push(entireSlot);
  }
  return slots;
};

export const handleNewSepcialHour = async component => {
  const { checkBoxRecurrEvent, checkBoxSpecificHour, specialHour, slotErrorMessages } = component.state;
  const { openErrorModal } = component.props;
  const returnSpecialHour = { ...specialHour };
  returnSpecialHour.slots = [];
  const key = moment(specialHour.day).format('MM-DD');
  const { slots } = specialHour;
  const hasErrors = Object.values(slotErrorMessages).some((errorMessage) => errorMessage !== '');
  if (hasErrors) {
    return;
  }
  try {
    slots.forEach(slot => {
      returnSpecialHour.slots = checkHours(returnSpecialHour.slots, slot);
    });
    if (_.isEmpty(returnSpecialHour.slots) && !checkBoxSpecificHour) {
      openErrorModal(ERROR_SAME_HOUR);
    } else {
      if (checkBoxSpecificHour) {
        delete returnSpecialHour.slots;
      }
      if (checkBoxRecurrEvent) {
        returnSpecialHour.day = key;
      } else {
        returnSpecialHour.day = moment(specialHour.day).format('YYYY-MM-DD');
      }
      await addSpecialHourToFirebase(returnSpecialHour, key);
      handleClose(component);
    }
  } catch {
    openErrorModal(ERROR_HORAIRE_SPECIFIC);
  }
};

export const handleRemoveSubmitSpecialHour = async component => {
  const { specialHourToRemove } = component.state;
  const { openErrorModal } = component.props;
  try {
    await removeSpecialHourOnFirebase(specialHourToRemove);
    handleClose(component);
  } catch {
    openErrorModal(ERROR_HORAIRE_SPECIFIC);
  }
};

export const handleChangeSpecificHours = (serviceNumber, time, fourchette, component) => {
  const { specialHour = {} } = component.state;
  const hour = `${time === '' ? '00:00' : time}`;
  const newSlots = [...specialHour.slots];
  component.setState((prevState) => ({
    slotErrorMessages: {
      ...prevState.slotErrorMessages,
      [serviceNumber]: (fourchette === 'start' && hour >= newSlots[serviceNumber].end) || (fourchette === 'end' && hour <= newSlots[serviceNumber].start)
        ? INCOHERENT_HOURS : ''
    }
  }));
  newSlots[serviceNumber] = {
    ...newSlots[serviceNumber],
    [fourchette]: hour
  };
  component.setState({
    specialHour: {
      ...specialHour,
      slots: newSlots
    }
  });
};

export const handleChangePage = (event, page, tabName, component) => {
  component.setState({ [tabName]: page });
};

export const handleChangeRowsPerPage = (event, tabName, component) => {
  component.setState({ [tabName]: event.target.value });
};
export const handleAddSepcificHour = component => {
  const { specialHour = {} } = component.state;
  specialHour.slots.push({
    start: '00:00',
    end: '23:59'
  });
  component.setState({ specialHour });
};
export const handleRemoveSpecificHours = (hour, component) => {
  const { specialHour = {} } = component.state;
  if (specialHour.slots.length > 1) {
    specialHour.slots.splice(hour, 1);
  }
  component.setState({ specialHour });
};

export const setSpecialHour = component => {
  component.setState({
    modalSpecialHours: true,
    checkBoxSpecificHour: false,
    checkBoxRecurrEvent: false,
    specialHour: {
      day: moment().toDate(),
      slots: [
        {
          start: '00:00',
          end: '23:59'
        }
      ]
    }
  });
};

export const handleClose = component => {
  component.setState({
    modalSpecialHours: false,
    modalRemoveSpecialHour: false,
    slotErrorMessages: {}
  });
};

export const handleChangeExpend = panel => (event, expanded, component) => {
  const balise = event.target.localName;
  if (balise !== 'path' && balise !== 'svg') {
    component.setState({
      expanded: { ...component.state.expanded, [panel]: expanded }
    });
  }
};
export const setStartDate = (date, component) => {
  const { specialHour } = component.state;
  component.setState({
    specialHour: {
      ...specialHour,
      day: date
    }
  });
};
